import React from "react";

function Header({ user, onLogout, onOpenPwModal, onToggleMenu, menuOpen, selectedMenu }) {
  

  return (
    <header className="header">
      <div className="header-left">
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={onToggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <h2>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* 💡 public 폴더 루트에서 찾도록 /를 붙이고, 이미지 크기를 명시합니다 */}
              <img 
                src="/favicon.ico" 
                alt="favicon" 
                style={{ width: "28px", height: "28px", objectFit: "contain" }} 
              />
              {/* 💡 글씨가 찌그러지거나 줄바꿈되지 않도록 고정합니다 */}
              <span style={{ fontSize: "20px", fontWeight: "bold", whiteSpace: "nowrap" }}>
                신청 접수 관리
              </span>
            </div>
          {/* 메뉴 선택에 따라 제목 변경 
            {selectedMenu && (
                <span style={{ marginLeft: "10px", fontSize: "1rem", color: "#ecf0f1" }}>
                    {selectedMenu === "board" && "파일 게시판"}
                    {selectedMenu === "manager" && "관리자 계정 관리"}
                    {selectedMenu === "user" && "사용자(교수/학생) 계정 관리"}
                </span>
            )}
          */}
        </h2>
      </div>
      <div className="header-right">
        <div className="user-info">
          <span onClick={onOpenPwModal} style={{ cursor: "pointer" }}>
            {user.name} 님
          </span>
          <button onClick={onLogout}>로그아웃</button>
        </div>
      </div>
    </header>
  );
}

export default Header;